import React from "react";
import { useState, useEffect } from "react";
import { Spinner, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import {
  createDoorStepEmployeeEarningUtilityListApi,
  updateDoorStepEmployeeEarningUtilityListApi,
} from "../../../services/DoorStepEmployeeService";
const AddDoorStepEmployeeUtilityModal = ({
  visible,
  onClose,
  onAfterSubmit,
  data = null,
}) => {
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    name: "",
    price: "",
    description: "",
  });
  const [error, setError] = useState({});
  useEffect(() => {
    if (visible) {
      handleReset();
    }
  }, [visible]);

  const handleReset = () => {
    if (data) {
      setForm({
        name: data?.name || "",
        price:Number(data?.price) || "",
        description: data?.description || "",
      });
    } else {
      setForm({
        name: "",
        price: "",
        description: "",
      });
    }

    setError({});
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    if (value && error[name]) {
      setError({ ...error, [name]: "" });
    }
  };

  const createUtility = () => {
    setLoading(true);
    createDoorStepEmployeeEarningUtilityListApi(form)
      .then((res) => {
        toast.success("Created Successfully");
        onAfterSubmit();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const editutility = () => {
    setLoading(true);
    updateDoorStepEmployeeEarningUtilityListApi(data?.id || "", form)
      .then((res) => {
        toast.success("Update Successfully");
        onAfterSubmit();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSubmit = () => {
    let error = {};
    if (!form?.name) {
      error.name = "Name Required";
    }
    if (!form?.price) {
      error.price = "Price Required";
    }

    setError(error);
    if (Object.entries(error).length == 0) {
      if (!data) {
        createUtility();
      } else {
        editutility();
      }
    }
  };
  return (
    <div>
      <Modal show={visible} onHide={onClose}>
        <Modal.Header closeButton>
          <Modal.Title>{data ? "Edit Brand" : "Add Brand"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row p-1 g-2">
            <div className="col-md-6">
              <label className="form-label text-dark">Name</label>
              <input
                type="text"
                className={`form-control ${error?.name ? "is-invalid" : ""}`}
                name="name"
                value={form?.name}
                placeholder="Tata"
                onChange={handleInputChange}
              />
              {error?.name && (
                <small className="text-danger">{error?.name}</small>
              )}
            </div>
            <div className="col-md-6">
              <label className="form-label text-dark">Price</label>
              <input
                type="text"
                className={`form-control ${error?.price ? "is-invalid" : ""}`}
                name="price"
                value={form?.price}
                placeholder="200"
                onChange={handleInputChange}
              />
              {error?.price && (
                <small className="text-danger">{error?.price}</small>
              )}
            </div>

            <div className="col-12">
              <label className="form-label text-dark">Description</label>
              <textarea
                rows={3}
                className="form-control"
                name="description"
                value={form?.description}
                placeholder="Type about this plan"
                onChange={handleInputChange}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-end gap-2 w-100">
            <span
              className="btn btn-outline-dark"
              disabled={loading}
              onClick={onClose}
            >
              Cancel
            </span>
            <button
              className="btn btn-primary"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading && (
                <Spinner
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              )}
              {data ? "Update" : "Submit"}
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AddDoorStepEmployeeUtilityModal;
